import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import AnnouncementList from "views/pages/announcement/AnnouncementList";
import AddAnnouncement from "views/pages/announcement/AddAnnouncement";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import Utility from "@core/helper/utility";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const Announcement = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [announcementList, setAnnouncementList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState("");
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");

  const location = useLocation();

  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteAnnouncement)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = announcementList.filter((o) => o.id !== id);
            setAnnouncementList(filter);
            fetchAnnouncementList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = announcementList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const annodata = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(annodata[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  useEffect(() => {
    fetchAnnouncementList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  const fetchAnnouncementList = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "DESC",
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getAnnouncementList)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setAnnouncementList(results);
          setTotalRecord(totalCount);
        } else {
          setAnnouncementList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitAnnouncement = () => {
    fetchAnnouncementList();
  };
  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Announcement
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <AnnouncementList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            handleOpen={handleOpen}
            announcementList={announcementList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchText={searchText}
            setSearchText={setSearchText}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
      {openModal && (
        <AddAnnouncement
          open={openModal}
          toggle={handleOpen}
          type={type}
          heading={type === "edit" ? "Update Announcement" : "Add Announcement"}
          onSubmitAnnouncement={submitAnnouncement}
          updateData={updateData}
          permission={permission}
          role={role}
        />
      )}
    </Grid>
  );
};

export default Announcement;
